<template>
    <div>
        <div class="row">
            <div class="col-12 text-left mb-3">
                <h5 class="align-self-center">Sua Localização</h5>
            </div>
            <div class="col-12 text-left">
                <label for="">Seu endereço</label>
                <vue-google-autocomplete
                    id="map"
                    ref="userAddres"
                    classname="form-control text-left"
                    placeholder="Pesquisar..."
                    @placechanged="getAddressData"
                    @no-results-found="notAddressFound"
                    @blur="loseFocus"
                >
                </vue-google-autocomplete>
            </div>
            <div class="col-12 text-left">
                <p v-if="(userData.location.lat == null || userData.location.lng == null) && userData.address" class="error_message m-0">
                    <small>Endereço inválido. Não será possível exibir o mapa. Tente selecionar outro endereço.</small>
                </p>
            </div>
            <div class="col-12 py-3 text-left" v-if="updated">
                <p class="text-success">Endereço atualizado.</p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import VueGoogleAutocomplete from 'vue-google-autocomplete';
    export default {
        data(){
            return{
                userData:{
                        address: '',
                    location:{
                        lat: null,
                        lng: null
                    }
                },
                errormessage: '',
                updated: false
            }
        },
        props:{
            siteId:{
                type: Number,
                required: true,
            }
        },
        methods:{
            loseFocus(){
                this.userData.address = this.$refs.userAddres.autocompleteText;
                this.userData.location.lat = null;
                this.userData.location.lng = null;
                setTimeout(() => {
                    this.saveData();
                }, 300);
            },
            notAddressFound(addressData){
                this.userData.location.lat = null;
                this.userData.location.lng = null;
                this.userData.address = addressData.name;
                setTimeout(() => {
                    this.saveData();
                }, 300);
            },
            loadAdress(){
                this.$refs.userAddres.update(this.address);
            },
            getAddressData(addressData, placeResultData, id) {
                this.userData.location.lat = addressData.latitude;
                this.userData.location.lng = addressData.longitude;
                this.userData.address = placeResultData.formatted_address;
                setTimeout(() => {
                    this.saveData();
                }, 300);
            },
            updateData(){
                let totalData = ''
                let token = this.$session.get('jwt')
                axios ({
                    method: 'get',
                    url: process.env.ROOT_API+'api/site/'+this.siteId,
                    data:  totalData,
                    headers: {
                        'Authorization': 'Bearer '+token,
                        'Content-Type': 'application/x-www-form-urlencoded' 
                    }
                })
                .then(response => {
                    this.address = response.data.address;
                    if(response.data.location){
                        this.userData.location = response.data.location;
                    }
                    this.loadAdress();
                })
            },
            saveData(){
                this.errormessage = '';
                var updadeProfile = this.userData;
                let token = this.$session.get('jwt');
                axios({
                    method: 'post',
                    url: process.env.ROOT_API+'/api/site/'+this.siteId+'/update/contact',
                    data: updadeProfile,
                    headers: {
                        'Authorization': 'Bearer '+token,
                        // 'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(response =>{
                    console.log(response);
                })
                .catch(response => {
                    //handle error
                    this.errormessage = response.data.error;
                    // console.log('Erro ao salvar');
                }) 
                this.updated = true;
                setTimeout(() => {
                    this.updated = false
                }, 2500);          
            }
        },
        components: {
            VueGoogleAutocomplete
        },
        created(){
            this.updateData()
        }
    }
</script>

<style scoped>
.error_message{
    color: #d61a1a;
}
.text-success{
    font-weight: 700;
    color: var(--main-color);
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/LocationComponent.vue